import { render, staticRenderFns } from "./saman.vue?vue&type=template&id=b49a2142"
import script from "./saman.vue?vue&type=script&lang=js"
export * from "./saman.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports